<template>
  <div class="m-table-box">
    <table>
      <thead>
        <tr>
          <th v-for="(item, index) in column" :key="index">
            <div class="th-block">
              <span>{{ item.title }}</span>
              <i
                v-if="item.sort"
                class="sort-icon"
                @click="sortHandler(item.prop)"
              />
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(item, index) in data"
          :key="index"
          :class="{ 'color-blue': item.hasDetail }"
          @click="handleLink(item)"
        >
          <td v-for="(m, i) in column" :key="`${index}_${i}`">
            <span class="color-blue">{{ item[m.prop] }}</span>
            <span v-if="item.type != 1">(代理)</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
// import { checkWx } from "@/wx/check";
export default {
  name: "MTable",
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    column: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      sortForBig: true,
    };
  },
  created() {},
  computed: {},
  methods: {
    sortHandler(prop) {
      if (this.sortForBig) {
        this.sortBigger(prop);
      } else {
        this.sortSmaller(prop);
      }
      this.sortForBig = !this.sortForBig;
    },
    sortBigger(prop) {
      this.data.sort((a, b) => {
        if (a[prop] > b[prop]) {
          return -1;
        } else if (a[prop] === b[prop]) {
          return 0;
        } else {
          return 1;
        }
      });
    },
    sortSmaller(prop) {
      this.data.sort((a, b) => {
        if (a[prop] < b[prop]) {
          return -1;
        } else if (a[prop] === b[prop]) {
          return 0;
        } else {
          return 1;
        }
      });
    },
    handleLink(item) {
      console.log(item, "==item");
      if (!window["wx"].invoke) {
        console.log("请先注册");
        return;
      }

      window["wx"].invoke(
        "openChatWithMsg",
        {
          userIds: item.uid,
          groupName: "",
          chatId: "",
        },
        function (res) {
          console.log("openChatWithMsg", res);
          if (res.err_msg !== "openChatWithMsg:ok") {
            // 获取创建的聊天id
            this.$toast("该用户还不是粤政易用户，请联系单位管理员");
          }
        }
      );
      // if (item.link) {
      //   this.$router.push(item.link);
      // }
    },
  },
};
</script>

<style lang="scss" scoped>
.m-table-box {
  background-color: #fff;
  font-size: 28px;
  color: #666;
  & > table {
    width: 100%;
    border: solid 1px #e7ebf0;
    // border-collapse: separate;
    border-spacing: 0;
    & > thead {
      th {
        background-color: #f8f9fb;
        height: 80px;
        & > .th-block {
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
    & > tbody {
      td {
        text-align: center;
        height: 80px;
        border-top: solid 1px #e7ebf0;
      }
    }
  }
  .sort-icon {
    width: 26px;
    height: 26px;
    display: inline-block;
    // background-image: url(../../assets/svg/sort.svg);
    background-size: cover;
    background-repeat: no-repeat;
    margin-left: 10px;
  }
}
.color-blue {
  color: #0070d5;
}
</style>
